// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.table-header-controls {
  display: flex;
  justify-content: space-between;
  align-items: end;
  margin-bottom: 0.5rem;
}

.search-export-controls {
  display: flex;
  gap: 0.5rem;
  align-items: end;
}

.execution-cell {
  display: flex;
  align-items: center;
  gap: 8px;
}

.date-picker-dropdown {
  position: fixed;
  background-color: white;
  border: 1px solid #ddd;
  border-radius: 6px;
  padding: 12px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  z-index: 9999;
  width: 200px;
}

.date-picker-title {
  font-size: 12px;
  font-weight: 600;
  color: #333;
  margin-bottom: 6px;
}

.date-picker-subtitle {
  font-size: 10px;
  color: #666;
  margin-bottom: 8px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.date-picker-input {
  width: 100%;
  padding: 6px;
  border: 1px solid #ccc;
  border-radius: 4px;
  font-size: 12px;
  margin-bottom: 8px;
  box-sizing: border-box;
}

.date-picker-actions {
  display: flex;
  justify-content: flex-end;
  gap: 6px;
}

.gap-2 {
  gap: 0.5rem;
}

.mb-2 {
  margin-bottom: 0.5rem;
}

.align-items-end {
  align-items: end;
}

.justify-content-between {
  justify-content: space-between;
}

.d-flex {
  display: flex;
}

.date-picker-dropdown {
  position: fixed !important;
  background-color: white;
  border: 1px solid #ddd;
  border-radius: 6px;
  padding: 10px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  z-index: 9999 !important;
  width: 200px;
  max-width: 250px;
  transform: none !important;
  margin: 0 !important;
}
.date-picker-dropdown .dropdown-header {
  font-size: 12px;
  font-weight: 600;
  color: #333;
  margin-bottom: 6px;
}
.date-picker-dropdown .dropdown-subtext {
  font-size: 10px;
  color: #666;
  margin-bottom: 8px;
  word-break: break-word;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.date-picker-dropdown .date-input {
  width: 100%;
  padding: 6px;
  border: 1px solid #ccc;
  border-radius: 4px;
  font-size: 12px;
  margin-bottom: 8px;
  box-sizing: border-box;
}
.date-picker-dropdown .button-row {
  display: flex;
  justify-content: flex-end;
  gap: 6px;
  margin-top: 8px;
}

.date-picker-btn {
  font-size: 10px !important;
  padding: 3px 6px !important;
  min-width: 50px !important;
  height: 24px !important;
}

.execution-cell .calendar-icon-btn:hover {
  background-color: #f0f0f0;
  border-radius: 3px;
}
.execution-cell .calendar-icon-btn:focus {
  outline: 2px solid #007acc;
  border-radius: 3px;
}

.action-buttons-wrapper {
  display: flex;
  gap: 4px;
  justify-content: center;
  align-items: center;
  overflow: hidden;
  max-width: 100%;
  flex-wrap: nowrap;
}

.request-page {
  position: relative;
}
.request-page .modal-header {
  font-family: Maersk Headline, sans-serif;
  font-size: 24px;
  font-weight: 500;
  line-height: 24px;
  letter-spacing: 0em;
  text-align: left;
  margin: 0px;
  padding: 0px 0px;
  border-bottom: none;
}
.request-page .action-items {
  position: absolute;
  right: 15px;
  top: 15px;
}
.request-page .tooltipvalue {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 130px;
  display: block;
}
.request-page .filter-section {
  padding: 10px;
  border: solid 1px #e0e0e0;
  margin-bottom: 20px;
  background: var(--color-white);
}
.request-page .filter-section .button-wrapper {
  white-space: nowrap;
  margin-top: 28px;
  width: 100%;
}
.request-page .filter-section .button-wrapper .button {
  width: 100%;
}
.request-page .filter-section .MultiSelect__value-container {
  height: 36px;
  overflow-x: hidden !important;
  overflow-y: auto;
}
.request-page .filter-section .MultiSelect__menu-list {
  overflow-x: hidden !important;
  overflow-y: auto;
}
.request-page .filter-section .MultiSelect__control, .request-page .filter-section label, .request-page .filter-section .form-control {
  font-size: 0.875rem;
}
.request-page .filter-section .dtco-date-range {
  height: 40px !important;
  border: 1px solid var(--border-color) !important;
}
.request-page .accordian-filter {
  border-bottom: 0 !important;
}
.request-page .accordian-filter .accordian-filter-header[type=button] {
  border-bottom: 1px solid var(--border-color);
  border-radius: 0;
}
.request-page .accordian-filter [type=date] {
  color: var(--color-text-grey) !important;
}
.request-page .accordian-filter-header > div > i {
  position: absolute;
  margin-top: -5px;
  border-radius: 10px;
  box-shadow: 0px 5px 3px 0px rgba(95, 27, 27, 0.2);
  background-color: #fafafa;
}
.request-page .accordian-filter-body {
  padding: 0;
}

.filters .filter-row {
  margin-right: 1rem;
}
.filters .filter-btn {
  padding-top: 1.8rem;
}
.filters .filter-btn button {
  cursor: pointer;
}

@media only screen and (max-width: 1340px) {
  .xs-btn {
    padding: 0px !important;
    min-height: 28px !important;
    min-width: 28px !important;
  }
  .xs-tag {
    padding: 3px;
    white-space: nowrap;
    font-size: 10px !important;
  }
}
.action-btns {
  display: flex;
  gap: 2px;
}`, "",{"version":3,"sources":["webpack://./src/pages/RequestPage/RequestPage.scss","webpack://./src/Styles/mixins.scss"],"names":[],"mappings":"AAEA;EACE,aAAA;EACA,8BAAA;EACA,gBAAA;EACA,qBAAA;AADF;;AAIA;EACE,aAAA;EACA,WAAA;EACA,gBAAA;AADF;;AAKA;EACE,aAAA;EACA,mBAAA;EACA,QAAA;AAFF;;AAMA;EACE,eAAA;EACA,uBAAA;EACA,sBAAA;EACA,kBAAA;EACA,aAAA;EACA,0CAAA;EACA,aAAA;EACA,YAAA;AAHF;;AAMA;EACE,eAAA;EACA,gBAAA;EACA,WAAA;EACA,kBAAA;AAHF;;AAMA;EACE,eAAA;EACA,WAAA;EACA,kBAAA;EACA,gBAAA;EACA,uBAAA;EACA,mBAAA;AAHF;;AAMA;EACE,WAAA;EACA,YAAA;EACA,sBAAA;EACA,kBAAA;EACA,eAAA;EACA,kBAAA;EACA,sBAAA;AAHF;;AAMA;EACE,aAAA;EACA,yBAAA;EACA,QAAA;AAHF;;AAOA;EACE,WAAA;AAJF;;AAOA;EACE,qBAAA;AAJF;;AAOA;EACE,gBAAA;AAJF;;AAOA;EACE,8BAAA;AAJF;;AAOA;EACE,aAAA;AAJF;;AAOA;EACE,0BAAA;EACA,uBAAA;EACA,sBAAA;EACA,kBAAA;EACA,aAAA;EACA,0CAAA;EACA,wBAAA;EACA,YAAA;EACA,gBAAA;EAGA,0BAAA;EACA,oBAAA;AANF;AAQE;EACE,eAAA;EACA,gBAAA;EACA,WAAA;EACA,kBAAA;AANJ;AASE;EACE,eAAA;EACA,WAAA;EACA,kBAAA;EACA,sBAAA;EACA,gBAAA;EACA,uBAAA;EACA,mBAAA;AAPJ;AAUE;EACE,WAAA;EACA,YAAA;EACA,sBAAA;EACA,kBAAA;EACA,eAAA;EACA,kBAAA;EACA,sBAAA;AARJ;AAWE;EACE,aAAA;EACA,yBAAA;EACA,QAAA;EACA,eAAA;AATJ;;AAaA;EACE,0BAAA;EACA,2BAAA;EACA,0BAAA;EACA,uBAAA;AAVF;;AAcI;EACE,yBAAA;EACA,kBAAA;AAXN;AAcI;EACE,0BAAA;EACA,kBAAA;AAZN;;AAiBA;EACE,aAAA;EACA,QAAA;EACA,uBAAA;EACA,mBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;AAdF;;AAiBA;EACE,kBAAA;AAdF;AAeE;ECzJA,wCAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,mBAAA;EACA,gBAAA;EACA,WAAA;EACA,gBAAA;EACA,mBAAA;AD6IF;AAOE;EACE,kBAAA;EACA,WAAA;EACA,SAAA;AALJ;AAOE;EACE,mBAAA;EACA,gBAAA;EACA,uBAAA;EACA,gBAAA;EACA,cAAA;AALJ;AAOE;EACE,aAAA;EACA,yBAAA;EACA,mBAAA;EACA,8BAAA;AALJ;AAMI;EACE,mBAAA;EACA,gBAAA;EACA,WAAA;AAJN;AAKM;EACE,WAAA;AAHR;AAMI;EACE,YAAA;EACA,6BAAA;EACA,gBAAA;AAJN;AAMI;EACE,6BAAA;EACA,gBAAA;AAJN;AAMI;EACE,mBAAA;AAJN;AAMI;EACE,uBAAA;EACA,gDAAA;AAJN;AAOE;EACE,2BAAA;AALJ;AAMI;EACE,4CAAA;EACA,gBAAA;AAJN;AAMI;EACE,wCAAA;AAJN;AAOE;EACE,kBAAA;EACA,gBAAA;EACA,mBAAA;EACA,iDAAA;EACA,yBAAA;AALJ;AAOE;EACE,UAAA;AALJ;;AAUE;EACE,kBAAA;AAPJ;AASE;EACE,mBAAA;AAPJ;AAQI;EACE,eAAA;AANN;;AAWA;EACE;IACE,uBAAA;IACA,2BAAA;IACA,0BAAA;EARF;EAUA;IACE,YAAA;IACA,mBAAA;IACA,0BAAA;EARF;AACF;AAUA;EACE,aAAA;EACA,QAAA;AARF","sourcesContent":["@use \"../../Styles/mixins.scss\";\n\n.table-header-controls {\n  display: flex;\n  justify-content: space-between;\n  align-items: end;\n  margin-bottom: 0.5rem;\n}\n\n.search-export-controls {\n  display: flex;\n  gap: 0.5rem;\n  align-items: end;\n}\n\n// Execution cell styling\n.execution-cell {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n// Date picker dropdown\n.date-picker-dropdown {\n  position: fixed;\n  background-color: white;\n  border: 1px solid #ddd;\n  border-radius: 6px;\n  padding: 12px;\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);\n  z-index: 9999;\n  width: 200px;\n}\n\n.date-picker-title {\n  font-size: 12px;\n  font-weight: 600;\n  color: #333;\n  margin-bottom: 6px;\n}\n\n.date-picker-subtitle {\n  font-size: 10px;\n  color: #666;\n  margin-bottom: 8px;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.date-picker-input {\n  width: 100%;\n  padding: 6px;\n  border: 1px solid #ccc;\n  border-radius: 4px;\n  font-size: 12px;\n  margin-bottom: 8px;\n  box-sizing: border-box;\n}\n\n.date-picker-actions {\n  display: flex;\n  justify-content: flex-end;\n  gap: 6px;\n}\n\n// Utility classes for spacing\n.gap-2 {\n  gap: 0.5rem;\n}\n\n.mb-2 {\n  margin-bottom: 0.5rem;\n}\n\n.align-items-end {\n  align-items: end;\n}\n\n.justify-content-between {\n  justify-content: space-between;\n}\n\n.d-flex {\n  display: flex;\n}\n\n.date-picker-dropdown {\n  position: fixed !important;\n  background-color: white;\n  border: 1px solid #ddd;\n  border-radius: 6px;\n  padding: 10px;\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);\n  z-index: 9999 !important;\n  width: 200px;\n  max-width: 250px;\n  \n  // Ensure it appears exactly where positioned\n  transform: none !important;\n  margin: 0 !important;\n  \n  .dropdown-header {\n    font-size: 12px;\n    font-weight: 600;\n    color: #333;\n    margin-bottom: 6px;\n  }\n  \n  .dropdown-subtext {\n    font-size: 10px;\n    color: #666;\n    margin-bottom: 8px;\n    word-break: break-word;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n  }\n  \n  .date-input {\n    width: 100%;\n    padding: 6px;\n    border: 1px solid #ccc;\n    border-radius: 4px;\n    font-size: 12px;\n    margin-bottom: 8px;\n    box-sizing: border-box;\n  }\n  \n  .button-row {\n    display: flex;\n    justify-content: flex-end;\n    gap: 6px;\n    margin-top: 8px;\n  }\n}\n\n.date-picker-btn {\n  font-size: 10px !important;\n  padding: 3px 6px !important;\n  min-width: 50px !important;\n  height: 24px !important;\n}\n.execution-cell {\n  .calendar-icon-btn {\n    &:hover {\n      background-color: #f0f0f0;\n      border-radius: 3px;\n    }\n    \n    &:focus {\n      outline: 2px solid #007acc;\n      border-radius: 3px;\n    }\n  }\n}\n\n.action-buttons-wrapper {\n  display: flex;\n  gap: 4px;\n  justify-content: center;\n  align-items: center;\n  overflow: hidden;\n  max-width: 100%;\n  flex-wrap: nowrap;\n}\n\n.request-page {\n  position: relative;\n  .modal-header {\n    @include mixins.modal-header-font;\n  }\n  .action-items {\n    position: absolute;\n    right: 15px;\n    top: 15px;\n  }\n  .tooltipvalue {\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    max-width: 130px;\n    display: block;\n  }\n  .filter-section {\n    padding: 10px;\n    border: solid 1px #e0e0e0;\n    margin-bottom: 20px;\n    background: var(--color-white);\n    .button-wrapper {\n      white-space: nowrap;\n      margin-top: 28px;\n      width: 100%;\n      .button{\n        width: 100%;\n      }\n    }\n    .MultiSelect__value-container {\n      height: 36px;\n      overflow-x: hidden !important;\n      overflow-y: auto;\n    }\n    .MultiSelect__menu-list {\n      overflow-x: hidden !important;\n      overflow-y: auto;\n    }\n    .MultiSelect__control, label, .form-control {\n      font-size: 0.875rem;\n    }\n    .dtco-date-range {\n      height: 40px !important;\n      border: 1px solid var(--border-color) !important;\n    }\n  }\n  .accordian-filter {\n    border-bottom: 0 !important;\n    .accordian-filter-header[type=button] {\n      border-bottom: 1px solid var(--border-color);\n      border-radius: 0;\n    }\n    [type=date] {\n      color: var(--color-text-grey)!important;\n    }\n  }\n  .accordian-filter-header>div>i {\n    position: absolute;\n    margin-top: -5px;\n    border-radius: 10px;\n    box-shadow: 0px 5px 3px 0px rgb(95 27 27 / 20%);\n    background-color: #fafafa;\n  }\n  .accordian-filter-body {\n    padding: 0;\n  }\n}\n\n.filters {\n  .filter-row {\n    margin-right: 1rem;\n  }\n  .filter-btn {\n    padding-top: 1.8rem;\n    button {\n      cursor: pointer;\n    }\n  }\n}\n\n@media only screen and (max-width : 1340px) {\n  .xs-btn {\n    padding: 0px !important;\n    min-height: 28px !important;\n    min-width: 28px !important;\n  }\n  .xs-tag{\n    padding: 3px;\n    white-space: nowrap;\n    font-size: 10px !important;\n  }\n}\n.action-btns{\n  display: flex;\n  gap: 2px;\n}\n","@mixin header-font {\n  font-family: Maersk Headline, sans-serif;\n  font-size: 36px;\n  font-weight: 300;\n  line-height: 40px;\n  letter-spacing: 0em;\n  text-align: left;\n}\n@mixin sub-header-font {\n  font-family: Maersk Headline, sans-serif;\n  font-size: var(--font-size-lg);\n  font-weight: 700;\n  line-height: 24px;\n  text-align: left;\n}\n@mixin modal-header-font {\n  font-family: Maersk Headline, sans-serif;\n  font-size: 24px;\n  font-weight: 500;\n  line-height: 24px;\n  letter-spacing: 0em;\n  text-align: left;\n  margin: 0px;\n  padding: 0px 0px;\n  border-bottom: none;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
